var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:phone-android-sharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0033 41.6663H29.3367V39.583H21.0033V41.6663ZM10.5867 47.9163V2.08301H39.7533V47.9163H10.5867ZM14.7533 33.333H35.5867V12.4997H14.7533V33.333Z",
    fill: "#152344"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtime);
export default __webpack_public_path__ + "static/media/airtime.4c0d334fd2123b70601dcfbd66691ac3.svg";
export { ForwardRef as ReactComponent };